// @flow
/* eslint-env node */
import React from 'react';
import ReactDOM from 'react-dom';
import init from './init';
import history from './services/history';
import Main from './modules/Main';

import './css/style.scss';

document.addEventListener('DOMContentLoaded', () => {
    // TODO: implement update hot loader
    // if(process.env.NODE_ENV !== 'production') {
    //     if (module.hot) {
    //         module.hot.accept();
    //     }
    // }

    const { store, initialData } = init();

    const container = document.getElementById('main-app');
    if(container === null) {
        throw new Error('Cannot render app. Container element not found');
    }

    const renderFn = (initialData.environment.ssr && !initialData.environment.streamingError) ? ReactDOM.hydrate : ReactDOM.render;
    // TODO: rewrite this to use historyCreator
    renderFn(
        <Main history={history} store={store} />,
        container
    );
});